import { Box, Text } from "@storyofams/react-ui";
import getSubTitle from "~lib/getSubTitle";
import { ShopifyRichText } from "../ShopifyRichText";
import { CrowdFunding } from "./CrowdFunding";
import { CustomerDivider } from "./CustomerDivider";
import { HeaderContainer } from "./HeaderContainer";
import { Icons } from "./Icons";
import { InfoAccordion } from "./InfoAccordion";
import { Links } from "./Links";
import { ReviewsOverview } from "./Overview";
import { SellingPoints } from "./SellingPoints";
import { SkinTypes } from "./SkinTypes";

export const Header = ({ product, story, content }) => {
  const description = product?.metafields?.find(
    (item) => item?.key === "description_excerpt"
  )?.value;
  const { title, subTitle } = getSubTitle(product.title);
  return (
    <HeaderContainer
      videoEmbed={story?.content?.video_embed}
      videoEmbedPreview={story?.content?.video_embed_preview}
      embedPreview={story?.content?.embed_thumbnail}
      position={"relative"}
      product={product}
      isReviewsDisabled={!story?.content?.isReviewsDisabled}
    >
      <Box display={"flex"} flexDirection={"column"}>
        <Box display={["none", "block"]}>
          <Text
            fontFamily="DINPro"
            fontWeight={700}
            fontSize={["40px", "56px"]}
            mb={subTitle ? 1 : 2}
            data-id={"title"}
          >
            {title}
          </Text>
          {subTitle && (
            <Text
              mb={"12px"}
              lineHeight={"22px"}
              fontWeight={500}
              color="#767473"
            >
              {subTitle}
            </Text>
          )}
          {!story?.content?.isReviewsDisabled && (
            <ReviewsOverview id={product?.id} />
          )}
        </Box>
      </Box>
      <Box order={[1, 0]}>
        <ShopifyRichText
          mb={
            product?.campaignEnabled?.value === "true"
              ? "25px"
              : ["24px", "30px"]
          }
          fontSize={["16px", "18px"]}
          content={description}
        />
        <SkinTypes product={product} />
        <InfoAccordion
          content={[
            ...(story?.content?.accordions ? story?.content?.accordions : []),
            {
              component: "product_choice",
              content: story?.content?.product_choice?.length
                ? story.content.product_choice
                : null,
              resolvedProducts: story?.content?.resolvedProducts,
            },
            {
              component: "bundle",
              content: product.variants.edges[0].node.components.nodes.length
                ? product.variants.edges[0].node.components.nodes
                : null,
            },
          ]}
        />
        {story?.content?.isIconsEnabled && (
          <Icons content={story?.content.icons} />
        )}
      </Box>

      {product?.campaignEnabled?.value === "true" ? (
        <CrowdFunding product={product} content={story?.content} />
      ) : (
        <Box mt={["20px", 0]} order={[0, 1]}>
          <CustomerDivider product={product} story={story} />
        </Box>
      )}
      <Links order={2} links={content?.links} />

      <SellingPoints order={3} items={content?.usps} />
    </HeaderContainer>
  );
};
